module.exports = __webpack_public_path__ + "img/gamesdk18.18bc39f.png";